import { createContext } from 'react';
import { IDishesByCustomerV2, IDishesByRestaurantV2, IItemForGetShortInfo } from 'types';

export type TSortBy = '' | 'DishesA-Z' | 'DishesZ-A';
export type TCountOfItems = '12' | '24' | '48';
export type TTypeOfModalWindow =
	| null
	| 'toConfirmDeleteItem'
	| 'success'
	| 'error'
	| 'assignRestaurants'
	| 'errorUpdatingDish'
	| 'errorDishHasPortions'
	| 'copyMenu'
	| 'errorCopyMenu'
	| 'editModGroupTemplate';
export interface IFilterValues {
	searchString: string;
	IDSelectedCustomer: Nullable<string>;
	IDSelectedRestaurant: Nullable<string>;
	IDSelectedCategory: Nullable<string>;
	IDSelectedSubcategory: Nullable<string>;
	isDisabled: Nullable<boolean>;
	assigned: boolean;
	sortBy: TSortBy;
	countOfItems: TCountOfItems;
	currentPage: number;
}

export interface IDishesState {
	needRefetchData: boolean;
	dishesByCustomer: IDishesByCustomerV2;
	dishesByRestaurant: IDishesByRestaurantV2;
	searchString: string;
	rememberMyChoice: boolean;
	fetchedCustomers: IItemForGetShortInfo[];
	IDSelectedCustomer: Nullable<string>;
	IDSelectedRestaurant: Nullable<string>;
	IDSelectedCategory: Nullable<string>;
	IDSelectedSubcategory: Nullable<string>;
	isDisabled: Nullable<boolean>;
	assigned: boolean;
	sortBy: TSortBy;
	countOfItems: TCountOfItems;
	currentPage: number;
	IDForDeletion: string;
	IDForAssignRestaurants: string;
	IDForEditModGroupTemplate: string;
	isInitializedSelectCustomerModal: boolean;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const dishesInitialState: IDishesState = {
	needRefetchData: false,
	dishesByCustomer: { totalCount: 0, items: [] },
	dishesByRestaurant: { totalCount: 0, items: [] },
	searchString: '',
	rememberMyChoice: true,
	fetchedCustomers: [],
	IDSelectedCustomer: null,
	IDSelectedRestaurant: null,
	IDSelectedCategory: null,
	IDSelectedSubcategory: null,
	isDisabled: null,
	assigned: false,
	sortBy: '',
	countOfItems: '12',
	currentPage: 1,
	IDForDeletion: '',
	IDForAssignRestaurants: '',
	IDForEditModGroupTemplate: '',
	isInitializedSelectCustomerModal: false,
	typeOfModalWindow: null,
};

export interface IDishesContext extends IDishesState {
	refetchData(value: boolean): void;
	deleteSelectedItem(): void;
	changeSearchString(value: string): void;
	toggleRememberMyChoice(): void;
	setFetchedCustomers(value: IItemForGetShortInfo[]): void;
	setIDCustomer(value: Nullable<string>): void;
	setIDRestaurant(value: Nullable<string>): void;
	setIDCategory(value: Nullable<string>): void;
	setIDSubcategory(value: Nullable<string>): void;
	toggleIsDisabled(): void;
	toggleAssigned(): void;
	resetSelectedControls(): void;
	setSortBy(sortBy: TSortBy): void;
	setCountOfItems(count: TCountOfItems): void;
	changeCurrentPage(page: number): void;
	setIDForDeletion(value: string): void;
	setIDForAssignRestaurants(value: string): void;
	setIDForEditModGroupTemplate(value: string): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	setFiltersFromQueryString(value: IFilterValues): void;
}

export const DishesContext = createContext<IDishesContext>({
	refetchData: () => undefined,
	deleteSelectedItem: async () => undefined,
	changeSearchString: () => undefined,
	toggleRememberMyChoice: () => undefined,
	setFetchedCustomers: () => undefined,
	setIDCustomer: () => undefined,
	setIDRestaurant: () => undefined,
	setIDCategory: () => undefined,
	setIDSubcategory: () => undefined,
	toggleIsDisabled: () => undefined,
	toggleAssigned: () => undefined,
	resetSelectedControls: () => undefined,
	setSortBy: () => undefined,
	setCountOfItems: () => undefined,
	changeCurrentPage: () => undefined,
	setIDForDeletion: () => undefined,
	setIDForAssignRestaurants: () => undefined,
	setIDForEditModGroupTemplate: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	setFiltersFromQueryString: () => undefined,
	...dishesInitialState,
});
